export const Origins = {
    foodit: "19",
    firstStepCheckout: "21",
    firstStepCheckoutFoodit: "21F",
    firstStepRediminPin: "22",
}